import Container from "react-bootstrap/Container";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import ManagementModal from "./ManagementModal";
import "./management.scss";
import ManagementDeleteModal from "./ManagementDeleteModal";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import Button from "@mui/material/Button";
import CreateIcon from "@mui/icons-material/Create";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import ManagementViewModal from "./ManagementViewModal";
import { errorToast } from "../../common/ToastMessage";
import Loader from "../../common/Loader";

function Management() {
  const navigate = useNavigate();
  const [issueManagement, setIssueManagement] = useState();
  const [open, setOpen] = useState(false);
  const [openView, setViewOpen] = useState(false);
  const [openDelete, setDeleteOpen] = useState(false);
  const [managementid, setManagementId] = useState();
  const [isAdd, setIsAdd] = useState(false);
  const [managmentData, setManagmentData] = useState({});
  const [selectedRow, setSelectedRow] = useState()
  const [isActive, setLoaderActive] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getissueManagementDetails();
  }, []);

  const getissueManagementDetails = async () => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    setLoaderActive(true)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Management`,
        {
          headers: headers,
        }
      );
      setLoaderActive(false)
      if (response.status === 400) {
        navigate("/login");
      }
      const data = response.data.data;
      const managmentData = data?.map((item, index) => {
        return { ...item, no: index + 1 };
      });
      setIssueManagement(managmentData);
    } catch (error) {
      console.log(error);
      setLoaderActive(false)
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      }
    }
  };

  const getManagementData = async (m_id) => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/api/Management/EmployeeGetById?id=${m_id}`,
        {
          headers: headers,
        }
      );
      setManagmentData(response?.data?.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };

  const openModal = async (isAdd, mID) => {
    setIsAdd(isAdd);
    if (!isAdd) {
      await getManagementData(mID);
      setManagementId(mID);
    } else {
      setManagmentData({});
      setManagementId("");
    }
    setOpen(true);
  };
  const closeModel = () => {
    setOpen(false);
  };
  const openViewModal = async (mID) => {
    setLoaderActive(true);
    await getManagementData(mID);
    setManagementId(mID);
    setViewOpen(true);
  };
  const closeViewModel = () => {
    setLoaderActive(false);
    setViewOpen(false);
  };
  const openDeleteModal = (mangementDeleteId) => {
    setManagementId(mangementDeleteId);
    setDeleteOpen(true);
  };
  const closeDeleteModal = (id) => {
    setManagementId(id);
    setDeleteOpen(false);
  };

  // Material Table Columns
  const columns = [
    { title: "No.", field: "no" },
    { title: "Name", field: "employeeName" },
    { title: "E-mail Id", field: "employEmailId" },
    {
      title: "Password",
      field: "password",
      render: (rowData) => {
        return (
          <span className="password-as-text">
            <input type={"password"} value={rowData.password} readOnly />
          </span>
        );
      },
    },
    { title: "Designation", field: "designation" },
    { title: "Assigned Project name", field: "assignProjectName" },
    {
      title: "Date of Issue",
      field: "dateOfIssue",
      render: (rowData) => {
        return moment(rowData?.dateOfIssue).format("DD/MM/YYYY");
      },
    },
    {
      title: "Action",
      field: "action",
      render: (rowData) => (
        <span>
          <Link
            href="#"
            className="edit me-3 "
            title="View"
            onClick={() => {
              openViewModal(rowData?.managementId);
            }}
          >
            <VisibilityIcon color="primary" />
          </Link>
          <Link
            href="#"
            className="edit me-3 "
            title="Edit"
            onClick={() => {
              openModal(false, rowData?.managementId);
            }}
          >
            <CreateIcon color="success" />
          </Link>
        </span>
      ),
    },
  ];

  const defaultMaterialTheme = createTheme();

  return (
    <>
      <Loader isLoading={isActive} />
      <div className="management">
        <div className="main-wrapper">
          <main className="main-sec active">
            <Container fluid className="custom-padding">
              <div className="">
                <ThemeProvider theme={defaultMaterialTheme}>
                  <div className="aad-btn-wrap">
                    <Button
                      variant="outlined"
                      onClick={() => {
                        openModal(true);
                      }}
                    >
                      Add New User
                    </Button>
                  </div>
                  <MaterialTable
                    title="Management"
                    options={{
                      selection: true,
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          selectedRow === rowData?.tableData?.id
                            ? "#F3F5F5"
                            : "#FFF",
                      }),
                      headerStyle: {
                        backgroundColor: "#E5F0FB",
                      },
                    }}
                    onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow?.tableData?.id)}
                    actions={[
                      {
                        tooltip: "Remove All Selected Users",
                        icon: "delete",
                        onClick: (evt, data) => {
                          let selectedUserData = [];
                          data?.map((dat) =>
                            selectedUserData.push(dat.managementId)
                          );
                          openDeleteModal(selectedUserData);
                        },
                      },
                    ]}
                    columns={columns}
                    data={issueManagement}
                  />
                </ThemeProvider>
              </div>
            </Container>
            {open && (
              <ManagementModal
                open={open}
                isAdd={isAdd}
                close={closeModel}
                managementid={managementid}
                managmentData={managmentData}
                getissueManagementDetails={getissueManagementDetails}
                setLoaderActive={setLoaderActive}
              />
            )}
            {openView && (
              <ManagementViewModal
                open={openView}
                close={closeViewModel}
                managementid={managementid}
                managmentData={managmentData}
                setLoaderActive={setLoaderActive}
              />
            )}
            {openDelete && (
              <ManagementDeleteModal
                managementId={managementid}
                open={openDelete}
                close={closeDeleteModal}
                getissueManagementDetails={getissueManagementDetails}
                setLoaderActive={setLoaderActive}
              />
            )}
          </main>
        </div>
      </div>
    </>
  );
}

export default Management;
